import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslate } from 'react-admin'

export const Footer: React.FC = () => {
  const translate = useTranslate()
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', mt: '1em' }}>
      <Typography variant="caption">
        {translate('resources.footer.text')}
      </Typography>
    </Box>
  )
}
